import React from "react";
import { Typography, Stack } from "digiwash-components";

interface SectionTitleType {
  title: string;
  action?: React.ReactNode;
  pb?: string;
}

function SectionTitle(props: SectionTitleType) {
  return (
    <Stack distribution="space-between" pb={props.pb}>
      <Typography ff="mainBold" color="neutrals.850">
        {props.title}
      </Typography>
      {props.action ? props.action : null}
    </Stack>
  );
}

export default SectionTitle;
